import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Minus, Plus } from "lucide-react";
import { FAQ_ITEMS } from "@/data/content";
import { Nav } from "@/components/Nav";
import { Seo } from "@/components/Seo";
import { Footer } from "@/components/Footer";
import { FadeUp, SectionHeading } from "@/components/Reveal";

const Item = ({ item, index }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-jawa-stone" data-testid={`faq-item-${index}`}>
      <button
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        data-testid={`faq-toggle-${index}`}
        className="flex w-full items-center justify-between gap-6 py-6 text-left transition-colors hover:text-jawa-coral"
      >
        <span className="font-serif text-xl font-medium text-jawa-espresso">{item.q}</span>
        <span className={`flex h-8 w-8 shrink-0 items-center justify-center border transition-colors ${open ? "border-jawa-coral bg-jawa-coral text-white" : "border-jawa-espresso/20 text-jawa-espresso/60"}`}>
          {open ? <Minus className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
        </span>
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden"
          >
            <p className="max-w-3xl pb-7 text-sm leading-relaxed text-jawa-espresso/70" data-testid={`faq-answer-${index}`}>
              {item.a}
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default function FaqPage() {
  return (
    <div className="bg-jawa-ivory" data-testid="faq-page">
      <Nav />
      <Seo
        title="FAQ — Questions About JÀWÀ Africa, Answered"
        description="Answers to the questions JÀWÀ hears most: memberships, guides, concierge scope, payments, bespoke itineraries and how everything works."
      />
      <main className="mx-auto max-w-4xl px-6 pb-24 pt-32 lg:px-10 lg:pt-40">
        <FadeUp>
          <SectionHeading overline="Questions, answered" title="Frequently asked questions" />
          <p className="mt-6 max-w-xl text-base leading-relaxed text-jawa-espresso/70">
            Everything about JÀWÀ — the journeys, the guides, memberships and how payment works at launch.
          </p>
        </FadeUp>
        <FadeUp className="mt-12 border-t border-jawa-stone">
          <div>
            {FAQ_ITEMS.map((item, i) => (
              <Item key={item.q} item={item} index={i} />
            ))}
          </div>
        </FadeUp>
      </main>
      <Footer />
    </div>
  );
}
